import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { contactData } from '../data/mock';

const MobileCTA = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${contactData.whatsapp}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${contactData.phone}`;
  };

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40"
      style={{
        background: 'rgba(0, 0, 0, 0.95)',
        backdropFilter: 'blur(24px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '16px',
        boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.5)'
      }}
    >
      <div className="flex gap-3">
        <button
          onClick={handleWhatsApp}
          className="btn-secondary"
          style={{
            flex: 1,
            padding: '14px',
            fontSize: '16px',
            minHeight: '52px'
          }}
        >
          <MessageCircle size={18} />
          WhatsApp
        </button>
        <button
          onClick={handleCall}
          className="btn-primary"
          style={{
            flex: 1,
            padding: '14px',
            fontSize: '16px',
            minHeight: '52px'
          }}
        >
          <Phone size={18} />
          Jetzt anrufen
        </button>
      </div>
    </div>
  );
};

export default MobileCTA;